import React from 'react';
import './Error.scss';
import ButtonMUI from '../../../shared/ButtonMUI';
import {Link} from 'react-router-dom';
import {mainPath} from '../../../routes/paths';
import ErrorImages from '../../../assets/images/auth/404.jpg';

const NotFound = () => {
  return (
    <div className='error-page__wrapper'>
      <div className='error-page__content'>
        <div className='error-page__images'>
          <img src={ErrorImages} alt='images' />
        </div>
        <div className='error-page__title'>Сторінка не знайдена</div>
        <div className='error-page__descriptions'>
          Неправильно набрана адреса або такої сторінки на сайті більше не існує
        </div>
        <ButtonMUI component={Link} to={mainPath.home}>
          Закрити
        </ButtonMUI>
      </div>

      <div className='error-page__subscribe'>© 2024 ДАР ®. Всі права захищено.</div>
    </div>
  );
};

export default NotFound;
